// extracted by mini-css-extract-plugin
export default {"root":"SideBar_root__n6zI4","toTop":"SideBar_toTop__fWjg8"};